import React, {Component} from 'react';

class ReceiptItem extends Component {

  render() {

    const {name, type, monthDiff} = this.props;
    return (
      <div className="receipt-item" id="receipt-item">
        <div className="">
          <h6 className="h6 margin-none">{ type === 'Package' ? 'Membership' : type }: </h6>
          <div>{name}</div><div>{monthDiff ? `for ${monthDiff} months` : null }</div>
        </div>
      </div>
    )
  }
}
export default ReceiptItem;


// WEBPACK FOOTER //
// src/client/components/site/features/account/transactionHistory/ReceiptItem.js